export const GET_NOTIFICATIONS_LIST = 'GET_NOTIFICATIONS_LIST'
export const GET_NOTIFICATIONS_LIST_SUCCESS = 'GET_NOTIFICATIONS_LIST_SUCCESS'
export const GET_NOTIFICATIONS_LIST_FAILED = 'GET_NOTIFICATIONS_LIST_FAILED'
export const RECIEVE_NOTIFICATIONS = 'RECIEVE_NOTIFICATIONS'
export const TOGGLE_NOTIFICATION = 'TOGGLE_NOTIFICATION'
export const DISABLE_TOGGLE = 'DISABLE_TOGGLE'
